<template>
  <div class="hzc-coke">
    <div class="content container">
      <div class="banner-left" @click="changeIndustrial">
        <p class="banner-title">{{ chainTitle }}</p>
        <div class="data1">
          {{ `${data1["druidParamName"]}` }} <em v-if="data1['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data1["price"] }}</span>
        </div>
        <div class="data2">
          {{ `${data2["druidParamName"]}` }}<em v-if="data2['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data2["price"] }}</span>
        </div>
        <div class="data3">
          {{ `${data3["druidParamName"]}` }}<em v-if="data3['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data3["price"] }}</span>
        </div>
        <div class="data4">
          {{ `${data4["druidParamName"]}` }}<em v-if="data4['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data4["price"] }}</span>
        </div>
        <div class="data5">
          {{ `${data5["druidParamName"]}` }}<em v-if="data5['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data5["price"] }}</span>
        </div>
        <div class="data6">
          {{ `${data6["druidParamName"]}` }}<em v-if="data6['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data6["price"] }}</span>
        </div>
        <div class="data7">
          {{ `${data7["druidParamName"]}` }}<em v-if="data7['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data7["price"] }}</span>
        </div>
        <div class="data8">
          {{ `${data8["druidParamName"]}` }}<em v-if="data8['price'] !== ''">:</em>
          <span style="color: #2ad3da">{{ data8["price"] }}</span>
        </div>
        <div
          class="differPrice1 redColor"
          v-if="chainPrice['differPrice1'] > 0"
        >
          {{ "+" + chainPrice["differPrice1"] }}
        </div>
        <div
          class="differPrice1 greenColor"
          v-if="chainPrice['differPrice1'] < 0"
        >
          {{ chainPrice["differPrice1"] }}
        </div>
        <div class="differPrice1" v-if="chainPrice['differPrice1'] === 0">
          —
        </div>
        <div
          class="differPrice2 redColor"
          v-if="chainPrice['differPrice2'] > 0"
        >
          {{ "+" + chainPrice["differPrice2"] }}
        </div>
        <div
          class="differPrice2 greenColor"
          v-if="chainPrice['differPrice2'] < 0"
        >
          {{ chainPrice["differPrice2"] }}
        </div>
        <div class="differPrice2" v-if="chainPrice['differPrice2'] === 0">
          —
        </div>
        <div
          class="differPrice3 redColor"
          v-if="chainPrice['differPrice3'] > 0"
        >
          {{ "+" + chainPrice["differPrice3"] }}
        </div>
        <div
          class="differPrice3 greenColor"
          v-if="chainPrice['differPrice3'] < 0"
        >
          {{ chainPrice["differPrice3"] }}
        </div>
        <div class="differPrice3" v-if="chainPrice['differPrice3'] === 0">
          —
        </div>
        <div
          class="differPrice4 redColor"
          v-if="chainPrice['differPrice4'] > 0"
        >
          {{ "+" + chainPrice["differPrice4"] }}
        </div>
        <div
          class="differPrice4 greenColor"
          v-if="chainPrice['differPrice4'] < 0"
        >
          {{ chainPrice["differPrice4"] }}
        </div>
        <div class="differPrice4" v-if="chainPrice['differPrice4'] === 0">
          —
        </div>
        <div
          class="differPrice5 redColor"
          v-if="chainPrice['differPrice5'] > 0"
        >
          {{ "+" + chainPrice["differPrice5"] }}
        </div>
        <div
          class="differPrice5 greenColor"
          v-if="chainPrice['differPrice5'] < 0"
        >
          {{ chainPrice["differPrice5"] }}
        </div>
        <div class="differPrice5" v-if="chainPrice['differPrice5'] === 0">
          —
        </div>
        <div
          class="differPrice6 redColor"
          v-if="chainPrice['differPrice6'] > 0"
        >
          {{ "+" + chainPrice["differPrice6"] }}
        </div>
        <div
          class="differPrice6 greenColor"
          v-if="chainPrice['differPrice6'] < 0"
        >
          {{ chainPrice["differPrice6"] }}
        </div>
        <div class="differPrice6" v-if="chainPrice['differPrice6'] === 0">
          —
        </div>
      </div>
      <div class="banner-right">
        <div class="title">
          <div class="title-write">行业动态</div>
          <span
            class="title-more fr"
            @click="toTwoPage('/coke/twoPage/industry')"
            >更多 ></span
          >
        </div>
        <div class="banner-right-content">
          <ul>
            <li v-for="(item, index) in industryList" :key="index">
              <p
                v-if="item.newsType === 1"
                @click="goDetail('/coke/industry', item.id, 2)"
              >
                {{ item.titleName }}
              </p>
              <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
              <span class="fr">{{ item.showTime }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="classification">
      <ul class="clearfix">
        <li style="position: relative">
          <img src="../../assets/home/qiye.png" alt="" />
          <span
            @click="toTwoPage('/coke/twoPage/enterprise')"
            style="
              right: 10px;
              position: absolute;
              top: 24px;
              color: #fff;
              cursor: pointer;
            "
          >
            >></span
          >
          <img
            src="../../assets/home/neibu.png"
            style="position: absolute; left: 183px; width: 70px; top: 24px"
            alt=""
          />
          <div class="classification-content">
            <!--            <Expect></Expect>-->
            <div
              class="classification-content-div"
              v-for="(item, index) in enterpriseList"
              :key="index"
            >
              <i></i>
              <p @click="goDetail('/coke/enterprise', item.collectionTime)">
                {{ item.showTimeword + "焦炭重点企业资讯" }}
              </p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
            <!-- <div class="classification-content-div" v-for="(item, index) in jiaotan" :key="index">
              <i></i>
              <p>{{ item.content }}</p>
              <span class="fr">{{ item.time }}</span>
            </div> -->
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'价格'"
            :flag="false"
            :unit="false"
            :url="'/coke/twoPage/price'"
            :params="{
              title: '价格指数',
              typeList: ['产地价格', '港口价格', '进出口价格'],
            }"
          ></ClassificationHeader>
          <div
            style="
              border: 1px solid #ccc;
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
            "
          >
            <span
              class="classification-tabs-two"
              @mouseover="priceFlag = 1"
              @click="
                reportToPage('/coke/twoPage/price', 'issue_coke_place_price')
              "
              :class="{ priceFlag: priceFlag === 1 }"
              >产地价格</span
            >
            <span
              class="classification-tabs-two"
              @mouseover="priceFlag = 2"
              @click="
                reportToPage('/coke/twoPage/price', 'issue_coke_port_price')
              "
              :class="{ priceFlag: priceFlag === 2 }"
              >港口价格</span
            >
            <span
              class="classification-tabs-two"
              @mouseover="priceFlag = 3"
              @click="
                reportToPage('/coke/twoPage/price', 'issue_coke_exit_price')
              "
              :class="{ priceFlag: priceFlag === 3 }"
              >进出口价格</span
            >
            <div class="classification-content" v-if="priceFlag === 1">
              <div
                class="classification-content-div price priceBgc"
                v-for="(item, index) in priceOneList"
                :key="index"
                @click="
                  goDetail(
                    '/coke/priceIndex',
                    item.completeOriginalDate,
                    'issue_coke_place_price'
                  )
                "
              >
                <img src="../../assets/home/jiage.jpg" alt="" />
                <p>{{ item.date + "焦炭产地价格" }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 2">
              <div
                class="classification-content-div price priceBgc"
                v-for="(item, index) in priceTwoList"
                :key="index"
                @click="
                  goDetail(
                    '/coke/priceIndex',
                    item.completeOriginalDate,
                    'issue_coke_port_price'
                  )
                "
              >
                <img src="../../assets/home/jiage.jpg" alt="" />
                <p>{{ item.date + "焦炭港口价格" }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
            <div class="classification-content" v-if="priceFlag === 3">
              <div
                class="classification-content-div price priceBgc"
                v-for="(item, index) in priceThreeList"
                :key="index"
                @click="
                  goDetail(
                    '/coke/priceIndex',
                    item.completeOriginalDate,
                    'issue_coke_exit_price'
                  )
                "
              >
                <img src="../../assets/home/jiage.jpg" alt="" />
                <p>{{ item.date + "焦炭进出口价格" }}</p>
                <span class="fr">{{ item.originalDate }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <div class="head" style="border-bottom: none">
            <em></em>
            <p>研究报告</p>
            <img
              src="../../assets/home/neibu.png"
              style="width: 70px; margin-left: 10px"
              alt=""
            />
            <span class="fr" @click="toTwoPage('/coke/twoPage/report')">
              >></span
            >
            <div class="report-tabs">
              <div
                class="tabs-i"
                :class="{ 'tabs-i-hover': reportFlag === 1 }"
                @click="reportToPage('/coke/twoPage/report', 1)"
                @mouseover="changeReportFlag(1)"
              >
                日报
              </div>
              <div
                class="tabs-i"
                :class="{ 'tabs-i-hover': reportFlag === 2 }"
                @click="reportToPage('/coke/twoPage/report', 2)"
                @mouseover="changeReportFlag(2)"
              >
                周报
              </div>
              <div
                class="tabs-i"
                :class="{ 'tabs-i-hover': reportFlag === 3 }"
                @click="reportToPage('/coke/twoPage/report', 3)"
                @mouseover="changeReportFlag(3)"
              >
                月报
              </div>
            </div>
          </div>
          <div class="classification-content research">
            <img
              style="width: 360px"
              src="../../assets/home/yanjiubaogao.png"
              alt=""
            />
            <div v-if="reportFlag === 1">
              <div
                class="classification-content-div"
                v-for="(item, index) in reportList"
                :key="index"
                @click="downloadReport(item)"
              >
                <i></i>
                <p style="width: 200px">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 2">
              <div
                class="classification-content-div"
                v-for="(item, index) in reportListWeek"
                :key="index"
                @click="downloadReport(item)"
              >
                <i></i>
                <p style="width: 200px">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
            <div v-if="reportFlag === 3">
              <div
                class="classification-content-div"
                v-for="(item, index) in reportListMonth"
                :key="index"
                @click="downloadReport(item)"
              >
                <i></i>
                <p style="width: 200px">{{ item.fileTitle }}</p>
                <span class="fr">{{ item.showTime }}</span>
              </div>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'产量'"
            :flag="true"
            :unit="false"
            :url="'/coke/twoPage/cokeYield'"
            :params="{ title: '产量' }"
          ></ClassificationHeader>
          <div class="classification-content">
            <div
              class="classification-content-div"
              v-for="(item, index) in cokeYield"
              :key="index"
            >
              <i></i>
              <p
                @click="
                  goDetail(
                    '/coke/cokeYield',
                    item.completeOriginalDate,
                    'issue_coke_group_province'
                  )
                "
              >
                {{ item.date + "焦炭产量分省" }}
              </p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'开工率'"
            :flag="true"
            :unit="false"
            :url="'/coke/twoPage/rate'"
            :params="{ title: '开工率' }"
          ></ClassificationHeader>
          <div class="classification-content">
            <div
              class="classification-content-div"
              v-for="(item, index) in rateList"
              :key="index"
            >
              <i></i>
              <p
                @click="
                  goDetail(
                    '/coke/operatingRate',
                    item.completeOriginalDate,
                    'issue_coke_rate'
                  )
                "
              >
                {{ item.date + "国内独立焦化厂开工率" }}
              </p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li class="coal_image">
          <div class="head">
            <em></em>
            <p>焦炭报表</p>
            <img src="../../assets/home/neibu.png" class="coal_report" alt="" />
          </div>
          <div class="col_one">
            <div class="col_one-li">
              <div class="col_one-card" @click="goCokeLink">
                <p class="icon">
                  <img
                    src="../../assets/images/report_icon1.png"
                    alt=""
                  />
                </p>
                <p class="name overflow1">焦企客户监控详情表</p>
              </div>
            </div>
            <div class="col_one-li">
              <div class="col_one-card" @click="goReportSummary">
                <p class="icon">
                  <img
                    src="../../assets/images/report_icon2.png"
                    alt=""
                  />
                </p>
                <p class="name overflow1">焦企客户监控汇总表</p>
              </div>
            </div>
          </div>
        </li>
        <!-- <li style="position: relative;cursor: pointer" @click="goCokeLink">
          <img style="margin-top: 10px;" src="../../assets/images/meitan.png" alt="">
          <p style="width: 250px;height: 33px;font-size: 24px;font-weight: 500;color: #FFFFFF;line-height: 33px;position: absolute;left: 34px;top:37px;">
            焦企客户监控表
            <img src="../../assets/home/neibu.png" style="width: 70px;vertical-align: middle" alt=""></p>
          <div
              style="width: 72px;height: 24px;background: rgb(241, 137, 51);border-radius: 12px;position: absolute;top: 113px;left: 40px;text-align: center;line-height: 24px;cursor: pointer;">
            <span style="width: 56px;height: 20px;font-size: 14px;font-weight: 500;color: #FFFFFF;line-height: 20px;">去查看→</span>
          </div>
        </li> -->
        <li style="position: relative">
          <img src="../../assets/home/lirun.png" alt="" />
          <img
            src="../../assets/home/neibu.png"
            style="width: 70px; position: absolute; left: 126px; top: 25px"
            alt=""
          />
          <span
            @click="toTwoPage('/coke/twoPage/cost')"
            style="
              right: 10px;
              position: absolute;
              top: 24px;
              color: #fff;
              cursor: pointer;
            "
          >
            >></span
          >
          <div class="classification-content">
            <div
              class="classification-content-div"
              v-for="(item, index) in costList"
              :key="index"
              @click="goDetail('/coke/cost', item.id, item.showYearTime)"
            >
              <i></i>
              <p>{{ item.showYearTime }}地区煤焦价格、价差测定表</p>
              <span class="fr">{{ item.showUpdateTime }}</span>
            </div>
          </div>
          <!-- <Expect></Expect> -->
        </li>
        <li>
          <ClassificationHeader
            :name="'库存'"
            :flag="false"
            :unit="false"
            :url="'/coke/twoPage/stock'"
            :params="{ title: '库存', typeList: ['焦化厂', '钢厂', '港口'] }"
          ></ClassificationHeader>
          <span
            class="classification-tabs-three"
            @mouseover="stockFlag = 1"
            @click="reportToPage('/coke/twoPage/stock', 'issue_coke_plant')"
            :class="{ stockFlag: stockFlag === 1 }"
            >焦化厂</span
          >
          <span
            class="classification-tabs-three"
            @mouseover="stockFlag = 2"
            @click="
              reportToPage('/coke/twoPage/stock', 'issue_coke_steel_mill')
            "
            :class="{ stockFlag: stockFlag === 2 }"
            >钢厂</span
          >
          <span
            class="classification-tabs-three"
            @mouseover="stockFlag = 3"
            @click="reportToPage('/coke/twoPage/stock', 'issue_coke_port')"
            :class="{ stockFlag: stockFlag === 3 }"
            >港口</span
          >
          <div class="classification-content" v-if="stockFlag === 1">
            <div
              class="classification-content-div price"
              v-for="(item, index) in stockOneList"
              :key="index"
              @click="
                goDetail(
                  '/coke/stock',
                  item.completeOriginalDate,
                  'issue_coke_plant'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "国内独立焦化厂100家" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="stockFlag === 2">
            <div
              class="classification-content-div price"
              v-for="(item, index) in stockTwoList"
              :key="index"
              @click="
                goDetail(
                  '/coke/stock',
                  item.completeOriginalDate,
                  'issue_coke_steel_mill'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "国内样本钢厂110家" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
          <div class="classification-content" v-if="stockFlag === 3">
            <div
              class="classification-content-div price"
              v-for="(item, index) in stockThreeList"
              :key="index"
              @click="
                goDetail(
                  '/coke/stock',
                  item.completeOriginalDate,
                  'issue_coke_port'
                )
              "
            >
              <i></i>
              <p>{{ item.date + "焦炭港口库存" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <div class="head">
            <em></em>
            <p>
              企业分布
              <b
                style="
                  color: #d3131a;
                  font-size: 18px;
                  margin-left: -5px;
                  font-weight: normal;
                "
                >地图</b
              >
            </p>
            <img
              src="../../assets/home/neibu.png"
              style="width: 70px; margin-left: 10px"
              alt=""
            />
          </div>
          <div class="classification-content" style="margin-top: 5px">
            <img
              style="cursor: pointer"
              src="../../assets/home/map.png"
              @click="goDetail('/coke/map')"
              alt=""
            />
            <!--            <Expect></Expect>-->
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'进出口量'"
            :flag="false"
            :unit="true"
            :url="'/coke/twoPage/exit'"
          ></ClassificationHeader>
          <div
            class="classification-content"
            style="margin-top: 8px"
            v-if="exitFlag === 1"
          >
            <div
              class="classification-content-div price"
              v-for="(item, index) in exitOneList"
              :key="index"
              @click="goDetail('/coke/exit', item.completeOriginalDate)"
            >
              <i></i>
              <p>{{ item.date + "焦炭进出口量" }}</p>
              <span class="fr">{{ item.originalDate }}</span>
            </div>
          </div>
        </li>
        <li>
          <ClassificationHeader
            :name="'焦化企业产能'"
            :flag="false"
            :unit="false"
            :url="'/coke/enterpriseCapacity'"
            :neibu="true"
            :params="{
              title: '焦化企业产能',
              typeList: [
                '焦化产能一览',
                '全国焦化产能区域分布',
                '按炉型产能分布',
              ],
            }"
          ></ClassificationHeader>
          <span
            class="classification-tabs-three"
            @mouseover="enterpriseCapacityFlag = 1"
            @click="reportToPage('/coke/enterpriseCapacity', '1')"
            :class="{ stockFlag: enterpriseCapacityFlag === 1 }"
            >焦化产能一览</span
          >
          <span
            class="classification-tabs-three"
            @mouseover="enterpriseCapacityFlag = 2"
            @click="reportToPage('/coke/enterpriseCapacity', '2')"
            :class="{ stockFlag: enterpriseCapacityFlag === 2 }"
            >焦化产能区域分布</span
          >
          <span
            class="classification-tabs-three"
            @mouseover="enterpriseCapacityFlag = 3"
            @click="reportToPage('/coke/enterpriseCapacity', '3')"
            :class="{ stockFlag: enterpriseCapacityFlag === 3 }"
            >按炉型产能分布</span
          >
          <div
            class="classification-content"
            @click="goDetail('/coke/enterpriseCapacity')"
            style="cursor: pointer"
          >
            <div
              id="myChartCapacity"
              style="width: 372px; height: 270px; cursor: pointer"
            ></div>
          </div>
        </li>
        <li style="position: relative">
          <img src="../../assets/home/dashuju2x.png" alt="" />
          <span
            style="
              position: absolute;
              right: 10px;
              top: 27px;
              cursor: pointer;
              color: #fff;
            "
            @click="
              toTwoPage(
                '/coke/twoPage/forecast',
                JSON.stringify({ url: '/coke', varieties: '焦炭' })
              )
            "
          >
            >></span
          >
          <img
            src="../../assets/home/neibu.png"
            style="width: 70px; position: absolute; left: 200px; top: 25px"
            alt=""
          />
          <div class="classification-content">
            <div
              class="classification-content-div map"
              v-for="(item, index) in forecastList"
              @click="goDetail('/coke/forecast', item.id, '/coke', '焦炭')"
              :key="index"
            >
              <i></i>
              <p>{{ item.showYearTime + item.predictType + "价格预测" }}</p>
              <span class="fr">{{ item.showEndTime }}</span>
            </div>
            <!--            <Expect @click="goDetail('/forecast')"></Expect>-->
          </div>
        </li>
        <li>
          <div class="head">
            <p class="red-title">新增/淘汰企业产能</p>
            <img
              src="../../assets/home/neibu.png"
              style="width: 70px; margin-left: 10px"
              alt=""
            />
          </div>
          <div class="classification-content">
            <div
              class="classification-content-div"
              v-for="(item, index) in boardList"
              :key="index"
            >
              <i></i>
              <p
                style="width: 220px"
                @click="goDetail('/coke/addCapacity', item.id)"
              >
                {{ item.showYearTime + "焦炭新增淘汰产能" }}
              </p>
              <span class="fr">{{ item.showTime }}</span>
            </div>
          </div>
        </li>
        <li style="position: relative">
          <ClassificationHeader
            :name="'技术及标准'"
            :flag="true"
            :unit="false"
            :url="'/coke/twoPage/standard'"
            :neibu="true"
            :params="{ title: '技术及标准' }"
          ></ClassificationHeader>
          <div class="exitClass">
            <div
              class="classification-content-div"
              v-for="(item, index) in standardList"
              :key="index"
            >
              <i></i>
              <p
                style="
                  width: 200px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                "
                @click="downloadReports(item)"
              >
                {{ item.fileTitle }}
              </p>
              <span class="fr" style="color: #777777; font-size: 12px">{{
                item.showTime
              }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <el-dialog
      custom-class="previewDialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      width="980px"
      :visible.sync="industrialFlag"
    >
      <CokeIndustrial
        :chainPrice="chainPrice"
        :chainTitle="chainTitle"
        :data1="data1"
        :data2="data2"
        :data3="data3"
        :data4="data4"
        :data5="data5"
        :data6="data6"
        :data7="data7"
        :data8="data8"
        @closeIndustrialCh="closeIndustrial"
      ></CokeIndustrial>
    </el-dialog>
  </div>
</template>

<script>
import ClassificationHeader from "@/components/common/ClassificationHeader";
import Expect from "@/components/common/expect";
import {
  priceNoAuthList,
  stockNoAuthList,
  rateNoAuthList,
  industryNoAuthList,
  exitNoAuthList,
  reportNoAuthList,
  boardNoAuthList,
  getNoAuthCompanyCoke,
  cokeYieldLine,
  cokeReportDetail,
  industryDetail,
  reportDetails,
  boardNoList,
  getAuthDetailReport,
  getAuthSummaryReport,
} from "@/api/coke";
import { chainList, forecastNoAuthList } from "@/api";
import { examineNoAuthList, getAuthFlagCoke } from "@/api/coke";
import CokeIndustrial from "@/components/bigChart/cokeIndustrial";
import { steelYieldNoAuthList } from "@/api/steel";

export default {
  name: "index",
  components: {
    ClassificationHeader,
    Expect,
    CokeIndustrial,
  },
  data() {
    return {
      industrialFlag: false,
      // 价格预测
      forecastList: [],
      // 行业动态
      industryList: [],
      // 研究报告
      reportList: [],
      reportListWeek: [],
      reportListMonth: [],
      standardList: [],
      reportFlag: 2,
      // 价格指数
      priceFlag: 1,
      priceOneList: [],
      priceTwoList: [],
      priceThreeList: [],
      // 库存
      stockFlag: 1,
      costList: [],
      enterpriseCapacityFlag: 1,
      stockOneList: [],
      stockTwoList: [],
      stockThreeList: [],
      // 开工率
      rateList: [],
      // 进出口量
      exitFlag: 1,
      exitOneList: [],
      exitTwoList: [],
      // 新增淘汰产能
      boardList: [],
      //分省产量
      cokeYield: [],
      // 产业链
      chainTitle: "",
      data1: {},
      data2: {},
      data3: {},
      data4: {},
      data5: {},
      data6: {},
      data7: {},
      data8: {},
      chainPrice: {},
      optionCapacity: {
        title: {
          // text: "ECharts 入门示例"
        },
        tooltip: {},
        xAxis: {
          data: [],
        },
        yAxis: {},
        series: [
          {
            data: [],
            type: "bar",
            barWidth: 20, //柱图宽度
            itemStyle: {
              normal: {
                color: "#F26D77",
              },
            },
          },
        ],
        grid: {
          x: 60,
          y: 25,
          x2: 10,
          y2: 50,
        },
      },
      enterpriseList: [],
    };
  },
  created() {
    this.getHomeList();
  },
  methods: {
    /**
     * 外链
     */
    goCokeLink() {
      getAuthDetailReport().then((res) => {
        if (res.msg) {
          this.$router.push("/coke/relatedProductsCoal");
        }
      });
    },
    goReportSummary() {
      getAuthSummaryReport().then((res) => {
        if (res.msg) {
          this.$router.push("/coke/reportSummary");
        }
      });
    },
    /**
     * 打开关闭模态
     */
    changeIndustrial() {
      this.industrialFlag = true;
    },
    closeIndustrial() {
      this.industrialFlag = false;
    },
    /**
     * 获取首页信息
     */
    getHomeList() {
      examineNoAuthList({ pageNum: 1, pageSize: 7 }).then((res) => {
        this.enterpriseList = res.rows;
      });
      // 产业链
      chainList({ dictDataType: "issue_coal_stell_chain_price" }).then(
        (res) => {
          this.chainTitle = res.data["data1"]["date"];
          this.data1 = res.data["data1"];
          this.data2 = res.data["data2"];
          this.data3 = res.data["data3"];
          this.data4 = res.data["data4"];
          this.data5 = res.data["data5"];
          this.data6 = res.data["data6"];
          this.data7 = res.data["data7"];
          this.data8 = res.data["data8"];
          this.chainPrice = res.data["price"];
        }
      );
      // 价格预测
      forecastNoAuthList({ pageNum: 1, pageSize: 7, varieties: "焦炭" }).then(
        (res) => {
          this.forecastList = res.rows;
        }
      );
      // 行业动态
      industryNoAuthList({ pageNum: 1, pageSize: 8, sourceType: 1 }).then(
        (res) => {
          this.industryList = res.rows;
        }
      );
      // 研究报告
      this.reportList = [];
      reportNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 1,
        fileType: 1,
      }).then((res) => {
        this.reportList = res.rows;
      });
      reportNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 1,
        fileType: 2,
      }).then((res) => {
        this.reportListWeek = res.rows;
      });
      reportNoAuthList({
        pageNum: 1,
        pageSize: 6,
        sourceType: 1,
        fileType: 3,
      }).then((res) => {
        this.reportListMonth = res.rows;
      });
      // 技术标准
      reportNoAuthList({
        pageNum: 1,
        pageSize: 7,
        sourceType: 1,
        fileType: 4,
      }).then((res) => {
        this.standardList = res.rows;
      });
      // 技术标准
      boardNoList({ pageNum: 1, pageSize: 7, sourceType: 1 }).then((res) => {
        this.costList = res.rows;
      });
      // 价格指数
      priceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coke_place_price",
        dataType: 1,
      }).then((res) => {
        this.priceOneList = res.rows;
      });
      priceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coke_port_price",
        dataType: 1,
      }).then((res) => {
        this.priceTwoList = res.rows;
      });
      priceNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coke_exit_price",
        dataType: 1,
      }).then((res) => {
        this.priceThreeList = res.rows;
      });
      // 库存
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coke_plant",
        dataType: 2,
      }).then((res) => {
        this.stockOneList = res.rows;
      });
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coke_steel_mill",
        dataType: 2,
      }).then((res) => {
        this.stockTwoList = res.rows;
      });
      stockNoAuthList({
        pageNum: 1,
        pageSize: 7,
        dictDataType: "issue_coke_port",
        dataType: 2,
      }).then((res) => {
        this.stockThreeList = res.rows;
      });
      // 开工率
      rateNoAuthList({
        pageNum: 1,
        pageSize: 8,
        dictDataType: "issue_coke_rate",
        dataType: 2,
      }).then((res) => {
        this.rateList = res.rows;
      });
      // 进出口量
      exitNoAuthList({
        pageNum: 1,
        pageSize: 8,
        dictDataType: "issue_coke_exit_import",
        dataType: 3,
      }).then((res) => {
        this.exitOneList = res.rows;
      });
      // 新增淘汰产能
      boardNoAuthList({ pageNum: 1, pageSize: 8 }).then((res) => {
        this.boardList = res.rows;
      });
      // 企业产能
      getNoAuthCompanyCoke().then((res) => {
        this.optionCapacity["xAxis"]["data"] = res.data["areaList"];
        this.optionCapacity["series"][0]["data"] = res.data["priceSumList"];
        this.drawChart();
      });
      // 分省产量
      steelYieldNoAuthList({
        pageNum: 1,
        pageSize: 8,
        dictDataType: "issue_coke_group_province",
        dataType: 3,
      }).then((res) => {
        this.cokeYield = res.rows;
      });
    },
    setScroll() {
      setTimeout(() => {
        this.$nextTick(() => {
          const waiceng = document.getElementById("waiceng");
          const neiwaiceng = document.getElementById("neiwaiceng");
          waiceng.scrollTop = neiwaiceng.clientHeight;
        });
      }, 200);
    },
    /**
     * 下载文件
     */
    downloadReport(row) {
      cokeReportDetail(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['焦炭', '研究报告', '正文'], row['id']);
      });
    },
    /**
     * 下载文件
     */
    downloadReports(row) {
      reportDetails(row["id"] + "/1").then((res) => {
        this.$setMenuInfoPath(['焦炭', '技术及标准', '正文'], row['id']);
      });
    },
    /**
     * 跳转二级页
     * @param url
     */
    toTwoPage(url, flag) {
      this.$router.push({ path: url, query: { flag } });
    },
    reportToPage(url, flag) {
      this.$router.push({ path: url, query: { flag } });
    },
    /**
     * 跳转详情页
     */
    goDetail(url, id, flag, other) {
      this.$router.push({
        path: `${url}`,
        query: { id: id, flag: flag, other: other },
      });
    },
    /**
     *  行业动态外链goDetail
     */
    openUrl(item) {
      industryDetail(item["id"]).then((res) => {
        window.openUrl(item.newsContent);
      });
    },
    /**
     * 切换研究报告tabs
     */
    changeReportFlag(flag) {
      this.reportFlag = flag;
    },
    /**
     * 地图配置加载
     */
    drawChart() {
      // 基于准备好的dom，初始化echarts实例【这里存在一个问题，请看到最后】
      let myChartCapacity = this.$echarts.init(
        document.getElementById("myChartCapacity")
      );
      // 使用刚指定的配置项和数据显示图表。
      myChartCapacity.setOption(this.optionCapacity);
    },
  },
};
</script>

<style scoped lang="less">
.coal_image {
  .head {
    color: #222222;
    height: 35px;
    font-size: 18px;
    line-height: 30px;
    position: relative;
    border-bottom: 2px solid #ccc;
    .coal_report {
      width: 70px;
      margin-left: 10px;
    }
    .red-title {
      width: 168px;
      height: 36px;
      background: #d3131a;
      border-radius: 4px 4px 0px 0px;
      color: #fff;
      text-align: center;
      line-height: 36px;
    }

    i {
      width: 60px;
      height: 2px;
      background: #cccccc;
      display: inline-block;
      position: absolute;
      bottom: 0;
    }

    em {
      width: 4px;
      height: 18px;
      background: #d3131a;
      font-style: normal;
      display: inline-block;
      margin-right: 9px;
      vertical-align: middle;
    }

    img {
      width: 44px;
      vertical-align: middle;
      margin-right: 9px;
    }

    p {
      font-size: 18px;
      display: inline-block;
      vertical-align: middle;
    }

    span {
      font-size: 12px;
      cursor: pointer;
      height: 20px;
      border-bottom: 1px solid #fff;
      position: absolute;
      right: 0;
      top: 2px;
    }

    span:hover {
      border-bottom: 1px solid #222;
    }
  }
  .col_one {
    display: flex;
    flex-wrap: wrap;
    padding: 10px 0;
    box-sizing: border-box;
    .col_one-li {
      width: 100%;
      padding: 6px 0;
      .col_one-card {
        padding-left: 10px;
        border-radius: 10px;
        box-sizing: border-box;
        background: #f7f8ff;
        cursor: pointer;
        height: 60px;
        display: flex;
        align-items: center;
        .icon {
          flex-shrink: 0;
          width: 28px;
          height: 28px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .name {
          flex: 1;
          padding-left: 10px;
          width: 0;
          font-size: 14px;
          line-height: 21px;
        }
        &:hover {
          box-shadow: 0px 8px 10px 0px rgba(131, 138, 167, 0.2);
          .name {
            color: #d3131a;
          }
        }
      }
    }
  }
}
.exitClass {
  .classification-content-div {
    margin-top: 8px;
  }

  p {
    max-width: 200px;
    display: inline-block;
    cursor: pointer;
    // 透明border
    border-style: solid;
    border-width: 1px;
    border-color: transparent;
  }

  p:hover {
    color: #d3131a;
    //border-bottom: 1px solid #D3131A;
    text-decoration: underline;
  }
}

.priceBgc:nth-child(2n + 0) {
  background-color: #f2f2f2;
}

.priceBgc {
  padding: 0 15px;
}

.content {
  height: 355px;
  width: 1200px;
  margin: 0 auto;

  .banner-left {
    width: 650px;
    height: 360px;
    display: inline-block;
    background: url("../../assets/steel/banner.png");
    background-size: 100% 100%;
    color: #fff;
    position: relative;
    cursor: pointer;

    img {
      width: 650px;
      height: 360px;
    }

    .banner-title {
      position: absolute;
      top: 30px;
      left: 272px;
    }

    .data1 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 29px;
      width: 106px;
      height: 50px;
    }

    .data2 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 179px;
      width: 106px;
      height: 50px;
    }

    .data3 {
      font-size: 4px;
      position: absolute;
      top: 251px;
      left: 176px;
      width: 115px;
      height: 50px;
    }

    .data4 {
      font-size: 10px;
      position: absolute;
      top: 134px;
      left: 345px;
      width: 106px;
      height: 50px;
    }

    .data5 {
      font-size: 10px;
      position: absolute;
      top: 39px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data6 {
      font-size: 10px;
      position: absolute;
      top: 128px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data7 {
      font-size: 10px;
      position: absolute;
      top: 215px;
      right: 20px;
      width: 106px;
      height: 50px;
    }

    .data8 {
      font-size: 10px;
      position: absolute;
      top: 305px;
      right: 18px;
      width: 119px;
      height: 50px;
    }

    .differPrice1 {
      position: absolute;
      top: 131px;
      left: 297px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice2 {
      position: absolute;
      top: 248px;
      left: 303px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice3 {
      position: absolute;
      top: 38px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice4 {
      position: absolute;
      top: 130px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice5 {
      position: absolute;
      top: 210px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }

    .differPrice6 {
      position: absolute;
      top: 295px;
      right: 155px;
      width: 25px;
      height: 25px;
      text-align: center;
      font-size: 12px;
    }
  }

  .banner-right {
    width: 510px;
    height: 360px;
    margin-left: 40px;
    display: inline-block;
    vertical-align: top;

    .title {
      width: 100%;
      border-bottom: 1px solid #ccc;
      height: 36px;
      line-height: 36px;

      .title-write {
        display: inline-block;
        width: 96px;
        height: 36px;
        background: #d3131a;
        border-radius: 4px 4px 0px 0px;
        text-align: center;
        line-height: 36px;
        color: #fff;
      }

      .title-more {
        cursor: pointer;
        color: #666666;
        font-size: 12px;
      }
    }

    .banner-right-content {
      ul {
        li {
          margin-top: 11px;

          p {
            display: inline-block;
            width: fit-content;
            max-width: 490px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: 20px;
            line-height: 20px;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            text-decoration: underline;
            color: #d3131a;
            //border-bottom: 1px solid #D3131A;
          }

          span {
            display: inline-block;
            height: 20px;
            font-size: 12px;
            color: #777777;
            line-height: 20px;
          }
        }
      }
    }
  }
}

.report-tabs {
  position: absolute;
  top: 3px;
  right: 11px;

  .tabs-i {
    display: inline-block;
    font-style: normal;
    margin-right: 10px;
    cursor: pointer;
    font-size: 14px;
  }

  .tabs-i:hover {
    color: #d3131a;
    border-bottom: 2px solid #d3131a;
  }
}

.tabs-i-hover {
  color: #d3131a;
  border-bottom: 2px solid #d3131a;
}

.classification {
  width: 1200px;
  margin: 0 auto;
  padding-top: 39px;

  ul {
    .last-li {
      border: 1px solid #cccccc;
      background: #f2f2f2;
      border-radius: 4px;
      width: 370px;

      .head {
        height: 40px;
        line-height: 40px;
      }

      .classification-content {
        overflow: auto;
        height: 211px;
        border-bottom: 1px solid #ccc;
      }

      .footer {
        height: 44px;
        padding-top: 6px;

        input {
          width: 283px;
          height: 31px;
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #cccccc;
          margin-left: 5px;
          padding-left: 10px;
        }

        .btn {
          cursor: pointer;
          display: inline-block;
          width: 61px;
          height: 34px;
          background: #cb081c;
          border-radius: 4px;
          vertical-align: middle;
          color: #fff;
          margin-left: 4px;
          text-align: center;
          line-height: 34px;
        }
      }
    }

    li {
      float: left;
      width: 372px;
      margin-right: 42px;
      height: 300px;
      margin-bottom: 43px;

      img {
        width: 372px;
      }

      .head {
        color: #222222;
        height: 35px;
        font-size: 18px;
        line-height: 30px;
        position: relative;
        border-bottom: 2px solid #ccc;

        .red-title {
          width: 168px;
          height: 36px;
          background: #d3131a;
          border-radius: 4px 4px 0px 0px;
          color: #fff;
          text-align: center;
          line-height: 36px;
        }

        i {
          width: 60px;
          height: 2px;
          background: #cccccc;
          display: inline-block;
          position: absolute;
          bottom: 0;
        }

        em {
          width: 4px;
          height: 18px;
          background: #d3131a;
          font-style: normal;
          display: inline-block;
          margin-right: 9px;
          vertical-align: middle;
        }

        img {
          width: 44px;
          vertical-align: middle;
          margin-right: 9px;
        }

        p {
          font-size: 18px;
          display: inline-block;
          vertical-align: middle;
        }

        span {
          font-size: 12px;
          cursor: pointer;
          height: 20px;
          border-bottom: 1px solid #fff;
          position: absolute;
          right: 0;
          top: 2px;
        }

        span:hover {
          border-bottom: 1px solid #222;
        }
      }

      .classification-tabs-two {
        width: 123px;
        height: 34px;
        line-height: 34px;
        display: inline-block;
        background: #f2f2f2;
        border-top: 2px solid #f2f2f2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .priceFlag {
        border-top: 2px solid #d3131a;
        background-color: #fff;
      }

      .classification-tabs-two:hover {
        border-top: 2px solid #d3131a;
        background-color: #fff;
      }

      .classification-tabs-three {
        width: 124px;
        height: 36px;
        line-height: 34px;
        display: inline-block;
        background: #f2f2f2;
        color: #222;
        text-align: center;
        cursor: pointer;
      }

      .stockFlag {
        background-color: #d3131a;
        color: #fff;
      }

      .classification-tabs-three:hover {
        background-color: #d3131a;
        color: #fff;
      }

      .classification-content {
        .classification-content-div {
          height: 33px;
          line-height: 33px;

          i {
            width: 4px;
            height: 4px;
            background: #9b857b;
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
          }

          p {
            max-width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            vertical-align: middle;
            cursor: pointer;
            // 透明border
            border-style: solid;
            border-width: 1px;
            border-color: transparent;
          }

          p:hover {
            color: #d3131a;
            //border-bottom: 1px solid #D3131A;
            text-decoration: underline;
          }

          span {
            color: #777777;
            font-size: 12px;
          }
        }

        .price {
          height: 33px;
          line-height: 33px;

          img {
            width: 8px;
            margin-right: 5px;
          }
        }

        .map {
          height: 32px;
          line-height: 32px;
        }
      }

      .research {
        width: 360px;
        height: 262px;
        border-radius: 0px 0px 4px 4px;
        border: 6px solid #dddddd;

        .classification-content-div {
          border-bottom: 1px dashed rgba(211, 19, 26, 0.25);
          height: 35px;
          line-height: 35px;
          margin-top: -1px;

          i {
            margin-left: 5px;
          }

          span {
            margin-right: 5px;
          }
        }

        .classification-content-div:last-child {
          border-bottom: none;
        }
      }
    }

    li:nth-child(3n + 0) {
      margin-right: 0;
    }
  }
}

.bulletin {
  padding: 12px;

  .top {
    img {
      width: 20px;
      border-radius: 50%;
      vertical-align: middle;
    }

    span {
      margin-left: 6px;
      color: #777;
    }

    em {
      color: #777;
      float: right;
      font-style: normal;
    }
  }

  .text {
    padding-left: 28px;
    word-break: break-all;
  }
}

.redColor {
  color: #ff6969;
}

.greenColor {
  color: #43e97b;
}
</style>
